import { Config } from '@generated/models';

export const isQuotationSignEnabled = (config: Config): boolean => config.featureFlags?.quotation_sign_enable === true;
